export default __webpack_public_path__ + "static/media/logo.c45353b0.svg";